export default "__VITE_ASSET__B$OjBx0G__"